import React, { useState } from "react";

export function HospitalBxBanner() {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "32px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1050,
        minWidth: "420px",
        maxWidth: "90vw",
        backgroundColor: "rgba(191, 205, 38, 0.92)",
        color: "#1a1a1a",
        borderRadius: "10px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        padding: "18px 56px 18px 28px",
        fontSize: "1.05rem",
        fontWeight: 700,
        textAlign: "center",
        letterSpacing: "0.2px",
        backdropFilter: "blur(2px)",
        animation: "hospitalBxBannerPulse 2.4s ease-in-out infinite",
      }}
    >
      <style>{`
        @keyframes hospitalBxBannerPulse {
          0%, 100% { box-shadow: 0 10px 30px rgba(0,0,0,0.25), 0 0 0 0 rgba(191,205,38,0.55); }
          50%      { box-shadow: 0 10px 30px rgba(0,0,0,0.25), 0 0 0 14px rgba(191,205,38,0); }
        }
      `}</style>
      <span>
        Este Portal está destinado exclusivamente para Asegurados de BX+
      </span>
      <button
        type="button"
        aria-label="Cerrar"
        onClick={() => setOpen(false)}
        style={{
          position: "absolute",
          top: "8px",
          right: "10px",
          background: "rgba(0,0,0,0.08)",
          border: "none",
          borderRadius: "50%",
          width: "28px",
          height: "28px",
          fontSize: "1.1rem",
          lineHeight: 1,
          color: "#1a1a1a",
          cursor: "pointer",
          fontWeight: 700,
        }}
      >
        &times;
      </button>
    </div>
  );
}

export default HospitalBxBanner;
